<template>
    <div id="aprication">
        <div class="headerp-div">
            <div class="header-div1">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :key="crumbs" v-for="crumbs in $crumbsList()">{{crumbs}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="header-div2" style="text-align: right">
                <div style="float: right">
                    <el-button size="mini" v-if="$hasPerm('business:pingZheng:add')" @click="handleAdd()"
                               style=";background-color:#16E3A1;color: white">新增<i class="el-icon-plus"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handleFind()" style=";background-color:#409EFF;color: white;">查询<i
                            class="el-icon-search"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="handlePrint()" style=";background-color:#1dcc34;color: white;">打印<i
                            class="el-icon-printer"></i></el-button>
                </div>
                <div style="float: right">
                    <el-button size="mini" @click="oneKeyPzPx()" style=";background-color:#f59523;color: white;">账期凭证连号<i
                            class="el-icon-help"></i></el-button>
                </div>
                <div style="float: right;margin-right: 5px;">
                    <el-select
                            size="mini"
                            v-model="isNrjz"
                            placeholder="是否结账"
                            clearable
                            style="width: 123px;background-color: #ffffff;"
                    >
                        <el-option label="已结账" value="1"/>
                        <el-option label="未结账" value="0"/>
                    </el-select>
                </div>
                <div style="float: right;margin-right: 5px;">
                    <el-select
                            v-model="pzz"
                            size="mini"
                            clearable
                            placeholder="凭证字"
                            style="width: 123px;background-color: #ffffff;"
                    >
                        <el-option v-for="item in pzzList" :label="item.pzz"
                                   :value="item.pzz"></el-option>
                    </el-select>
                </div>
                <div style="float: right;margin-right: 5px;">
                    <el-input
                            class="queryInput"
                            size="mini"
                            placeholder="请输入摘要"
                            v-model="zy"
                            clearable>
                    </el-input>
                </div>
                <div style="float: right">
                    <el-date-picker
                            @change="dateChang"
                            class="queryPzDate"
                            size="mini"
                            v-model="dateValues"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            unlink-panels
                            :picker-options="pickerOptions">
                    </el-date-picker>
                </div>
            </div>
        </div>

        <el-table
                height="500"
                :row-style="{height: '0'}"
                :cell-style="{padding: '3.5px',color:'#606266',fontSize:'13.5px'}"
                :header-row-style="{height: '40px'}"
                :header-cell-style="{padding: '5px',fontSize:'14px',color:'#909399'}"
                :data="tableData"
                :span-method="objectSpanMethod"
                :row-class-name="rowClassName"
                @cell-mouse-enter="handleMouseEnter"
                @cell-mouse-leave="handleMouseLeave"
                @selection-change="handleSelectionChange"
                size="mini"
                id="elTableIdWW"
                border
                style="width: 100%; margin-top: 20px">
            <el-table-column
                    type="selection"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="pzDate"
                    label="凭证日期"
                    width="136">
            </el-table-column>
            <el-table-column
                    label="凭证字号"
                    width="136">
                <template slot-scope="scope">
                    <a style="color: #409EFF;cursor: pointer" @click="handleEdit(scope.row)">{{scope.row.pzzZh}}</a>
                    <span style="color: #f56c26;margin-left: 15px;font-weight: bold" v-if="scope.row.syjz == '1'">[结转]</span>
                </template>

            </el-table-column>
            <el-table-column
                    min-width="156" :show-overflow-tooltip="true"
                    prop="zyJl"
                    label="摘要">
            </el-table-column>
            <el-table-column
                    min-width="156" :show-overflow-tooltip="true"
                    prop="kmmc"
                    label="科目">

                <template slot-scope="scope">
                    {{scope.row.kmdm}}
                    {{scope.row.kmmc}}
                </template>

            </el-table-column>
            <el-table-column
                    prop="jfje"
                    label="借方金额(元)">

                <template slot-scope="scope">
                    <span style="color:red" v-if="scope.row.jfje < 0">{{scope.row.jfje}}</span>
                    <span v-else>{{scope.row.jfje}}</span>
                </template>

            </el-table-column>
            <el-table-column
                    prop="dfje"
                    label="贷方金额(元)">
                <template slot-scope="scope">
                    <span style="color:red" v-if="scope.row.dfje < 0">{{scope.row.dfje}}</span>
                    <span v-else>{{scope.row.dfje}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    width="116"
                    prop="zdr"
                    label="制单人">
            </el-table-column>
            <el-table-column label="操作" width="115.6">
                <template slot-scope="scope">

                    <span style="margin-right: 5px;" v-if="scope.row.isNrjz=='1'">已结账</span>

                    <el-button size="mini" type="text" style="margin-right: 5px;" v-if="$hasPerm('business:pingZheng:edit') && scope.row.isNrjz=='0'" @click="handleEdit(scope.row)">
                        修改
                    </el-button>

                    <el-dropdown size="mini" @command="(command) => handleCommand(command, scope.row)"  v-if="$hasPerm('business:pingZheng:remove,business:pingZheng:add')">
                        <span class="el-dropdown-link">
                          <i class="el-icon-d-arrow-right"></i>更多
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="handleDelete" icon="el-icon-view" v-if="$hasPerm('business:pingZheng:remove') && scope.row.isNrjz=='0'">删除</el-dropdown-item>
                            <el-dropdown-item command="handleCopy" icon="el-icon-notebook-2" v-if="$hasPerm('business:pingZheng:add')">复制</el-dropdown-item>
                            <el-dropdown-item command="handleChongHong" icon="el-icon-notebook-2" v-if="$hasPerm('business:pingZheng:add')">冲红</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
                style="margin-top: 5px;"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[5, 10, 20, 50, 90, 500]"
                :page-size="pageSize"
                :current-page="currentPage"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
        ></el-pagination>
        <edit v-if="editVisible" ref="edit" @handleCurrentChange="handleCurrentChange"></edit>
        <print v-if="printVisible" ref="print"></print>
    </div>
</template>
<script>
    import Edit from './edit'
    import Print from './print'

    export default {
        name: 'PrintPingZhengList',
        components: {
            Edit,
            Print
        },
        data() {
            let _this = this;
            return {
                currentPage: 1, //初始页
                pageSize: 5, //    每页的数据
                total: 0,
                offset: 0,
                tableData: [],
                printRow: [],
                pzzList: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '本期',
                        onClick(picker) {
                            picker.$emit('pick', [_this.currZqStartDate, _this.currZqEndDate]);
                        }
                    }, {
                        text: '上期',
                        onClick(picker) {
                            picker.$emit('pick', [_this.lastZqStartDate, _this.lastZqEndDate]);
                        }
                    }, {
                        text: '本月',
                        onClick(picker) {
                            let date = new Date();
                            // 2.获取今日的年月
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            picker.$emit('pick', [new Date(year,month,1), new Date(year, month + 1, 0)]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            let date = new Date();
                            // 2.获取今日的年月
                            let year = date.getFullYear();
                            let month = date.getMonth();
                            picker.$emit('pick', [new Date(year,month-1,1), new Date(year, month, 0)]);
                        }
                    }]
                },
                dateValues: [],
                editVisible: false,
                printVisible: false,
                zy: '',
                isNrjz: '',
                pzz: '',
                startDate: null,
                endDate: null,
                currZqStartDate: null,
                currZqEndDate: null,
                lastZqStartDate: null,
                lastZqEndDate: null
            }
        },
        methods: {
            handleCurrentChange(cPage) {
                this.offset = (cPage - 1) * this.pageSize;
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/list'),
                    method: 'get',
                    params: {
                        'offset': this.offset,
                        'limit': this.pageSize,
                        'isNrjz': this.isNrjz,
                        'zy': this.zy,
                        'pzz': this.pzz,
                        'startDate': this.startDate,
                        'endDate': this.endDate
                    }
                }).then(res => {
                    if (res.data.code == 0) {
                        this.tableData = res.data.data.page.rows;
                        this.total = res.data.data.page.total;

                        this.startDate = res.data.data.startDate;
                        this.endDate = res.data.data.endDate;
                        this.dateValues = res.data.data.dateValues;

                        this.currZqStartDate = res.data.data.currZqStartDate;
                        this.currZqEndDate = res.data.data.currZqEndDate;

                        this.lastZqStartDate = res.data.data.lastZqStartDate;
                        this.lastZqEndDate = res.data.data.lastZqEndDate;
                    } else {
                        this.$message({ // 失败
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                }).finally(r => {
                })

            },
            dateChang() {
                if (this.dateValues != null && this.dateValues.length > 0) {
                    this.startDate = this.dateValues[0];
                    this.endDate = this.dateValues[1];
                }else{
                    this.startDate = null;
                    this.endDate = null;
                }
            },
            handleSelectionChange(val) {
                this.printRow = val;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.handleCurrentChange(1);
            },
            // 合并规则
            objectSpanMethod({row, column, rowIndex, columnIndex}) {
                if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 7 || columnIndex === 8) {
                    if (row.rowFirst === true) {
                        return {
                            rowspan: row.rowspan,
                            colspan: 1
                        }
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        }
                    }
                }
            },
            // 给相应的rowIndex添加类名
            rowClassName({row}) {
                return row.pzId;
            },
            // 鼠标进入单元格
            handleMouseEnter(row) {
                $("." + row.pzId + "").addClass("in-row");
            },
            // 鼠标离开
            handleMouseLeave(row) {
                $("." + row.pzId + "").removeClass("in-row");
            },
            handleFind() {
                this.handleCurrentChange(1);
            },
            oneKeyPzPx() {
                this.$confirm('将本账期凭证重新连号, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/pingZheng/oneKeyPzPx'),
                        method: 'post',
                        data: {}
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCurrentChange(1);
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    }).finally(r => {})

                }).catch(() => {});
            },
            handleAdd() {
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(null,0);
                })
            },
            handlePrint(){
                if(this.printRow.length==0){
                    this.$message({
                        type: 'warning',
                        message: '请选择需要打印的凭证！'
                    })
                    return;
                }
                this.printVisible = true;
                this.$nextTick(() => {
                    this.$refs.print.int(this.printRow);
                })
            },
            handleEdit(row) {
                let id = row.pzId;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id,1);
                })
            },
            handleCopy(row) {
                let id = row.pzId;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id,2);
                })
            },
            handleChongHong(row) {
                let id = row.pzId;
                this.editVisible = true;
                this.$nextTick(() => {
                    this.$refs.edit.int(id,3);
                })
            },
            // 更多操作触发
            handleCommand(command, row) {
                switch (command) {
                    case "handleDelete":
                        this.handleDelete(row);
                        break;
                    case "handleCopy":
                        this.handleCopy(row);
                        break;
                    case "handleChongHong":
                        this.handleChongHong(row);
                        break;
                }
            },
            getPzzList() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/pingZheng/getPzzList'),
                    method: 'post'
                }).then(res => {
                    this.pzzList = res.data.data;
                })
            },
            handleDelete(row) {

                this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let id = row.pzId
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/pingZheng/remove'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCurrentChange(1);
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    }).finally(r => {})

                }).catch(() => {});

            }
        },
        created: function () {
            this.handleCurrentChange(this.currentPage);
            this.getPzzList();
        }
    }
</script>
<style scoped>

    .header-div1 {
        margin-bottom: 5px;
        float: left;
        width: 20%;
    }

    .header-div2 {
        margin-bottom: 5px;
        float: left;
        width: 80%;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .el-table--mini {
        font-size: 13px;
    }

    .queryPzDate {
        margin-right: 5px;
    }

    .el-dropdown {
        color: #3ea9f9;
        font-size: 12px;
        cursor: pointer;
    }

    #aprication >>> .el-table--border td, .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #aprication >>> .el-table--border th {
        border-right: 1px solid #ddd !important;
    }

    #aprication >>> .el-table td, .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #aprication >>> .el-table th.is-leaf {
        border-bottom: 1px solid #ddd !important;
    }

    #aprication >>> .el-table {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-right: 1px solid #ddd;
    }
</style>

<style>
    .el-table .in-row {
        background: #f2f4f7;
    }
</style>